import { API_BASE_URL } from './api';

interface Admin {
  admin_id: number;
  admin_name: string;
  admin_email: string;
  admin_type: string;
  admin_status: 'Active' | 'Inactive';
  dateadded: string;
  dateupdated: string;
}

export const adminAPI = {
  // Get all admins
  // Get all admins
getAllAdmins: async (): Promise<Admin[]> => {
  const response = await fetch(`${API_BASE_URL}/manage-admins`, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const data = await response.json();

  // Handle multiple possible structures safely
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.data)) return data.data;
  if (Array.isArray(data.data?.admins)) return data.data.admins;
  return [];
},


  // Get admin by ID
  getAdminById: async (id: number): Promise<Admin> => {
    const response = await fetch(`${API_BASE_URL}/manage-admins/${id}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const data = await response.json();
    return data.data;
  },

  // Create new admin
  createAdmin: async (adminData: Omit<Admin, 'id' | 'created_at' | 'updated_at'>): Promise<Admin> => {
    const response = await fetch(`${API_BASE_URL}/manage-admins`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(adminData)
    });
    const data = await response.json();
    return data.data;
  },

  // Update admin
  updateAdmin: async (id: number, adminData: Partial<Admin>): Promise<Admin> => {
    const response = await fetch(`${API_BASE_URL}/manage-admins/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(adminData)
    });
    const data = await response.json();
    return data.data;
  },

  // Delete admin
  deleteAdmin: async (id: number): Promise<void> => {
    await fetch(`${API_BASE_URL}/manage-admins/${id}`, {
      method: 'DELETE'
    });
  }
};
